// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"5064":"2699784e","12589":"b381f555","76449":"d9bf2730","89103":"f58203c0"}[chunkId] + ".css";
};